/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsRecommendedProducts = {
  init: async function($section) {

    // Add settings from schema to current object
    Shopify.theme.jsRecommendedProducts = $.extend(this, Shopify.theme.getSectionData($section));

    // Look for an element with class 'product-recommendations'
    const $productRecommendations = $section.find('.product-recommendations');

    // Selectors
    const productID = $productRecommendations.data('product-id');
    const limit = $productRecommendations.data('limit');

    const sectionID = $productRecommendations.data('section-id');

    // Resolve matching items before choosing the four related products.
    const looks = [...document.querySelectorAll('ls-complete-look')];
    if (looks.length) {
      await customElements.whenDefined('ls-complete-look');
      await Promise.all(looks.map(look => look.ready));
    }

    // If showing custom collection we do not want to build request url
    if (this.show_custom_collection) {
      this.showCustomCollection($section);
      return;
    }

    // Build request URL
    const shopURL = $productRecommendations.data('base-url');
    const requestUrl = `${shopURL}?section_id=${sectionID}&limit=${limit}&product_id=${productID}`;

    $.ajax({
      type: 'GET',
      url: requestUrl,
      success: function(data) {

        const $result = $(data).find('.product-recommendations');
        Shopify.theme.jsRecommendedProducts.filterProducts($result, $productRecommendations);
        let $recommendedProductsElement = $result.html();

        // Insert product list into the product recommendations container
        $productRecommendations.html($recommendedProductsElement);
        $productRecommendations.prop('hidden', !$productRecommendations.find('.thumbnail').length);

        Shopify.theme.jsProduct.relatedProducts();

        // Initialize shopify payment buttons
        if (Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        // Converting the currencies
        if (Shopify.theme.currencyConverter) {
          Shopify.theme.currencyConverter.convertCurrencies();
        }
      }
    });
  },
  setupRecommendedVideoPlayer: function($section) {
    const videosInRecommendedProducts = $section.find('[data-product-recommendations-container] [data-html5-video] video, [data-product-recommendations-container] [data-youtube-video]').get();

    // Only run Plyr.setup if videosInRecommendedProducts exists
    if (videosInRecommendedProducts.length > 0) {
      videosInRecommendedProductsPlayer = Plyr.setup(videosInRecommendedProducts, {
        controls: videoControls,
        fullscreen: {
          enabled: true,
          fallback: true,
          iosNative: true
        },
        storage: {
          enabled: false
        }
      });
      if (videoPlayers !== null) {
        var combinedArray = videoPlayers.concat(videosInRecommendedProductsPlayer);
        videoPlayers = combinedArray;
      } else {
        videoPlayers = videosInRecommendedProductsPlayer;
      }
    }

    Shopify.theme.jsVideo.setupListeners();
  },
  // Compare product handles so collection URLs and variant query strings match too.
  filterProducts: function($content, $container) {
    const productKey = href => {
      if (!href) return null;
      try {
        return new URL(href, window.location.origin).pathname.match(/\/products\/([^/]+)/)?.[1] || null;
      } catch (_) { return null; }
    };
    const excluded = new Set([productKey($container.attr('data-product-url'))]);
    document.querySelectorAll('ls-complete-look[data-has-products="true"] .ls-look-card a[href]').forEach(link => {
      excluded.add(productKey(link.href));
    });
    const limit = Number($container.attr('data-display-limit')) || 4;
    let count = 0;
    $content.find('.thumbnail').each(function() {
      const key = productKey(this.querySelector('a[href*="/products/"]')?.getAttribute('href'));
      if (!key || excluded.has(key) || count >= limit) {
        this.remove();
      } else {
        excluded.add(key);
        count++;
      }
    });
    $content.find('.slider-gallery').attr('data-products-available', count).attr('data-products-limit', count);
  },
  showCustomCollection: function($section) {
    const $container = $section.find('.product-recommendations');
    this.filterProducts($container, $container);
    $container.prop('hidden', !$container.find('.thumbnail').length);
    Shopify.theme.jsProduct.relatedProducts();
  },
  unload: function($section) {
  }
}

/******/ })()
;